import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { getAvatar } from '@/scripts/utils/genAvatar';
import DeleteIcon from '../images/delete.svg?react';
import styles from './index.module.scss';

interface SelectedMembersProps {
  selectedMembers: ChatGroupMember[];
  onMemberDelete: (member: ChatGroupMember) => void;
}

export default function SelectedMembers({
  selectedMembers,
  onMemberDelete,
}: SelectedMembersProps) {
  return (
    <div className={styles.membersList}>
      {selectedMembers.length > 0 && (
        <div className={styles.membersListTitle}>
          Selected: {selectedMembers.length}{' '}
          {selectedMembers.length > 1 ? 'Members' : 'Member'}
        </div>
      )}
      <div className={cls(styles.membersListContentWrapper, 'scrollbar_hover')}>
        <div className={styles.membersListContent}>
          {selectedMembers.map((member) => (
            <div className={styles.membersListItem} key={member.user_id}>
              <MyAvatar src={getAvatar(member.avatar, member.name)} info={member} />
              <div className={styles.membersContent}>
                <div className={styles.membersNames}>
                  <div className={styles.name}>{member.name}</div>
                  {member.username && (
                    <div className={styles.uname}>@{member.username}</div>
                  )}
                </div>
                <DeleteIcon
                  className="pointer"
                  onClick={() => onMemberDelete(member)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
